import { render, staticRenderFns } from "./widget-store.vue?vue&type=template&id=0b59a0da&scoped=true&"
import script from "./widget-store.vue?vue&type=script&lang=js&"
export * from "./widget-store.vue?vue&type=script&lang=js&"
import style0 from "./widget-store.vue?vue&type=style&index=0&id=0b59a0da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b59a0da",
  null
  
)

export default component.exports